import React from 'react';
import Card from '../Card/Card';
import './SimilarProduct.css';
const SimilarProduct = ({ simillarCard , title}) => {

    return (
        <div className="container smilar-block mt-4" id='Gallery'>
            <h1 className='text-center similar-product-title'>{title}</h1>
            <div className="row">
                {
                    simillarCard?.map((item, index) => (
                        <div className="col-md-3 col-sm-6" key={index}>
                            <Card item={item}
                             type={item?.category} 
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default SimilarProduct;